import BaseChangeset from './base';
export class ResetPasswordChangeset extends BaseChangeset {}